import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { SettingsProvider } from './context/SettingsContext';
import './index.css';

// Parse URL parameters when in embed mode
const params = new URLSearchParams(window.location.search);
const embedConfig = {
  acquisition: Number(params.get('acquisition')) || 20,
  retention: Number(params.get('retention')) || 85,
  shareOfWallet: Number(params.get('shareOfWallet')) || 0,
  initialCustomers: Number(params.get('initialCustomers')) || 50,
  monthlyRevenue: Number(params.get('monthlyRevenue')) || 1500,
  yAxisMaxValue: Number(params.get('yAxisMaxValue')) || 1250000,
};

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <SettingsProvider initialSettings={embedConfig}>
      <App />
    </SettingsProvider>
  </StrictMode>
);